import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/pact-footprints`;

// PACT ProductFootprint export (LEI-enriched companyIds). Phase 1, GLEIF/vLEI.
export const pactFootprintService = {
  getFootprints: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data; // { data: [ ...ProductFootprint ] }
  },

  getFootprint: async (id) => {
    const response = await axios.get(`${API_BASE}/${encodeURIComponent(id)}`);
    return response.data; // ProductFootprint
  },

  // Async dVE verification (Strategy B pub/sub transport)
  verifyFootprint: async (id, { nodeId, replace = true } = {}) => {
    const response = await axios.post(`${API_BASE}/${encodeURIComponent(id)}/verify`, {
      node_id: nodeId,
      replace,
    });
    return response.data; // { correlation_id, node_id, status: 'PENDING', ... }
  },

  getVerification: async (id) => {
    const response = await axios.get(`${API_BASE}/${encodeURIComponent(id)}/verification`);
    return response.data; // { status: PENDING|COMPLETED|ERROR, result, error, ... }
  },
};

export default pactFootprintService;

// Extract the LEI from a companyIds array (urn:lei:<LEI>), or null.
export function leiFromCompanyIds(companyIds) {
  if (!Array.isArray(companyIds)) return null;
  const urn = companyIds.find((id) => String(id).toLowerCase().startsWith('urn:lei:'));
  return urn ? String(urn).slice('urn:lei:'.length) : null;
}
